import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'timeFormat',
    standalone: false
})
export class TimeFormatPipe implements PipeTransform {

  transform(value: string): string {
    if (!value) return value;

    // Split the input time into hours and minutes
    let [hour, minute] = value.split(':').map(Number);

    // Determine AM or PM
    let period = hour >= 12 ? 'PM' : 'AM';

    // Convert to 12-hour format
    hour = hour % 12 || 12;

    // Format the result as 'hh:mm AM/PM'
    let formattedTime = `${hour}:${minute.toString().padStart(2, '0')} ${period}`;

    return formattedTime;
  }

}
